import(/* webpackMode: "eager" */ "/vercel/path0/src/app/footer/safety/page.js");
